import { render, staticRenderFns } from "./UnauthorizedView.vue?vue&type=template&id=e6d12006&scoped=true"
import script from "./UnauthorizedView.vue?vue&type=script&lang=js"
export * from "./UnauthorizedView.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedView.vue?vue&type=style&index=0&id=e6d12006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d12006",
  null
  
)

export default component.exports